<template>
  <v-container grid-list-md text-xs-left>
    
    <v-layout row wrap>
      <v-flex xs12 class="display-1 font-weight-light">
          CONNECT
      </v-flex>

      <v-flex xs12>
          <p></p>
        <p>Visit the links below to connect with your FAA colleagues and the broader community.  Learning on the job with colleagues is a vital component in your development.</p>
      </v-flex>

          <v-btn to="/avsed" class="mt-5 mr-5">AVSED</v-btn>
          <v-btn to="/rotationalasgn" class="mt-5 mr-5">Rotational Assignments</v-btn>
          <v-btn to="/yammer" class="mt-5 mr-5"><v-icon>mdi-yammer</v-icon></v-btn>

    </v-layout>
   
  </v-container>
</template>

<script>

  export default {
    data () {
        return {
        image: require('@/assets/ThinkstockPhotos-516589445.jpg')
        }
    }
  }</script>

<style>

</style>
